var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPensjon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "30px",
    viewBox: "0 0 34 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Color/32-content/box-2 Copy 4@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 33.6,
    height: 33.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GDPR-Personopplysning",
    transform: "translate(-309.000000, -5123.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color/24-business-finance/piggy-bank",
    transform: "translate(309.000000, 5119.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fillRule: "evenodd",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.000000, 4.200000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4000001,24.8724001 L21.7000001,25.1328001 C20.1712001,25.6200001 18.5248001,25.9000001 16.8000001,25.9000001 C15.3462397,25.9000001 13.933927,25.7109588 12.6000001,25.3552109 L12.6000001,28.0000001 C12.6000001,28.7731987 11.9731987,29.4000001 11.2000001,29.4000001 C10.4268014,29.4000001 9.80000007,28.7731987 9.80000007,28.0000001 L9.80000007,24.3067022 C7.3113182,23.0876971 5.27906958,21.223862 4.04600002,18.9000001 L0.700000003,18.9000001 C0.313600001,18.9000001 -7.10542736e-14,18.5850001 -7.10542736e-14,18.2000001 L-7.10542736e-14,12.6000001 C-7.10542736e-14,12.2136001 0.313600001,11.9 0.700000003,11.9 L3.01700001,11.9 C3.62880002,9.00620004 5.50900002,6.38120003 8.27120003,4.57380002 C7.99540003,3.48740001 7.28000003,2.53400001 6.29860003,1.96700001 C6.08300003,1.84100001 5.95000002,1.61140001 5.95000002,1.36080001 C5.95000002,1.1102 6.08300003,0.879200004 6.29860003,0.756000003 C7.15260003,0.260400001 8.12140003,-4.58300065e-13 9.10000004,-4.58300065e-13 C10.9382,-4.58300065e-13 12.6546001,0.910000004 13.6962001,2.40660001 C14.7378001,2.20220001 15.7794001,2.10000001 16.8000001,2.10000001 C24.1962001,2.10000001 30.2554001,7.00280003 30.7510001,13.1852001 C31.5882001,12.9094001 32.2000001,12.1296001 32.2000001,11.2 C32.2000001,10.8136 32.5136001,10.5 32.9000001,10.5 C33.2864001,10.5 33.6000001,10.8136 33.6000001,11.2 C33.6000001,12.9024001 32.3750001,14.3206001 30.7622001,14.6328001 C30.5356775,18.2536771 28.4035512,21.4475524 25.2000001,23.4994156 L25.2000001,28.0000001 C25.2000001,28.7731987 24.5731987,29.4000001 23.8000001,29.4000001 C23.0268014,29.4000001 22.4000001,28.7731987 22.4000001,28.0000001 L22.4000001,24.8724001 L22.4000001,24.8724001 Z",
    id: "Path",
    fill: "#E3B0A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40000003,12.6000001 C7.62720003,12.6000001 7.00000003,11.9714001 7.00000003,11.2000001 C7.00000003,10.4272001 7.62720003,9.80000005 8.40000003,9.80000005 C9.17140004,9.80000005 9.80000004,10.4272001 9.80000004,11.2000001 C9.80000004,11.9714001 9.17140004,12.6000001 8.40000003,12.6000001 Z",
    id: "Path",
    fill: "#59514B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6586001,9.4634814 C23.5214001,9.68352533 23.3114001,9.79942633 23.0986001,9.79942633 C22.9530001,9.79942633 22.8046001,9.74399542 22.6786001,9.62977414 C20.8082001,7.94333057 18.4814001,7.11858575 16.1462001,7.30335547 C15.7654001,7.33527024 15.4266001,6.9858875 15.4014001,6.52228349 C15.3748001,6.06035921 15.6674001,5.65890501 16.0538001,5.62866997 C18.7306001,5.41702466 21.3808001,6.3593502 23.5200001,8.28767413 C23.8294001,8.56650842 23.8910001,9.09226225 23.6586001,9.4634814 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#D6897D",
    cx: 7.00000007,
    cy: 16.1000001,
    rx: 2.8,
    ry: 3.5
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPensjon);
export default __webpack_public_path__ + "static/media/Pensjon.cc77ef2c4a3cee01fe369df7cc8fa7cc.svg";
export { ForwardRef as ReactComponent };